import { Avatar as AvatarANTD, AvatarProps } from 'antd';

export const Avatar = (props: AvatarProps) => {
  return <AvatarANTD {...props} />;
};
